
import Utils from "../util/Utils"
import { configStore } from "../state/CommonState"
import { Card } from "../v3-componets/AgCard"
import { Headspan } from "../v3-componets/AgHeadspan"
import pepiconspopperson from "../assets/images/pepicons-pop_person.svg";
export default function LCLChargesViewRequestApproval(props) {
    let isMailBody=props.isMailBody
    let totalcurrency = "INR"
    if(props.totalcurrency!=undefined && props.totalcurrency.length>0){
        totalcurrency = props.totalcurrency
    }

    const Tn = ({ i, name }) => {
        const e = props.data[i]
        if (e.disabled && e.disabled.indexOf(name) >= 0)
            return (
                <div style={{ color: '#dddddd', border: 'none' }} >.</div>
            )
        else if (name === 'total') {
            return (
                <span style={{ textAlign: 'right' }}>{Utils.N(e[name], e.currency)}</span>
            )
        } else {
            let num = e[name]
            num = isNaN(num) ? 0.0 : Number(num)
            return num != 0 ? <span>{Utils.N(num, e.currency)}</span> : <></>
        }
    }
    const displayRec = (e) => {
        const perCBM = parseFloat(e.perCBM)
        const perTon = parseFloat(e.perTon)
        const perShipment = parseFloat(e.perShipment)
        const total = parseFloat(e.total)
        console.log(perCBM, perTon, perShipment, total)
        if (perCBM != 0 || perTon != 0 || perShipment != 0 || total != 0) return true
        return false
    }

    let grandTotal = 0.0
    let volumeDiscount = 0.0
    props.data.map(e => {
        let erate = configStore.getExchangeRateinr(e)
        if (!erate || erate === 0) erate = 1.0
        if (e.chargeDescription == 'Volume Discount') {
            volumeDiscount = (e.total * erate)
            if (volumeDiscount > 0) volumeDiscount *= -1
        } else {
            grandTotal += parseFloat(e.total) * erate
        }
        console.log('E.TOTAL***=', e.total, grandTotal, e.currency, erate)
    })
    let counter = 1

    let checkValue = false;
    props.data.forEach(element => {
        if((+element.perCBM) !== 0 || (+element.perShipment) !== 0 || (+element.perTon) !== 0 || (+element.minimum) !== 0 || (+element.maximum) !== 0 || (+element.total) !== 0){
            checkValue = true;
        }
    });
    return (
        <>
            {checkValue ?
            <>
            <div style={{fontSize: "0.8rem"}}>
                                    <div className="table-container">
                <table className="table is-bordered is-striped is-narrow is-hoverable ">
                    <thead>
                        <tr>
                            <td colSpan={12}>
                                <div style={{
                                    width: '100%',
                                    textAlign: 'center',
                                    backgroundColor: '#ffeee0',
                                    fontSize: '1.1rem',
                                    fontWeight: 'bold'
                                }}>{props.chargeType}</div>
                            </td>
                        </tr>
                        <tr>
                            <th></th>
                            <th></th>
                            <th></th>
                            
                                        <th colSpan='4' className="has-text-centered">Per Unit</th>
                                        <th></th>
                           
                            <th></th>
                        </tr>
                        <tr>
                            <th>#</th>
                            <th style={{ textAlign: 'center' }}>Charge Description</th>
                            <th>On Account</th>
                            <th>Currency</th>
                           
                                        <th style={{ textAlign: 'center' }}>Per CBM</th>
                                        <th style={{ textAlign: 'center' }}>Per Ton</th>
                                        <th style={{ textAlign: 'center' }}>Minimum</th>
                                        <th style={{ textAlign: 'center' }}>Maximum</th>
                                        <th style={{ textAlign: 'center' }}>Per Shipment</th>
                            
                            <th style={{ textAlign: 'right' }}>Total</th>
                        </tr>
                    </thead>
                    <tbody>
                    {
                            props.data
                                .filter(e => e.chargeDescription != 'Volume Discount')
                                .map((e, i) => {
                                    {
                                        return (displayRec(e)) ?
                                        
                                            <tr key={e.id}>
                                                <td >{counter++}</td>
                                                <td>{
                                            
                                                e.chargeDescription
                                        }</td>
                                        <td>{e.onaccount}</td>
                                                <td>{e.currency}</td>
                                              
                                                    <td style={{ textAlign: 'center' }}><Tn i={i} name='perCBM' /></td>
                                                    <td style={{ textAlign: 'enter' }}><Tn i={i} name='perTon' /></td>
                                                    <td style={{ textAlign: 'center' }}><Tn i={i} name='minimum' /></td>
                                                    <td style={{ textAlign: 'center' }}><Tn i={i} name='maximum' /></td>
                                                    <td style={{ textAlign: 'center' }}><Tn i={i} name='perShipment' /></td>
                                            
                                        <td style={{ textAlign: 'right' }}><Tn i={i} name='total' /></td>
                                            </tr> : <></>
                                    }
                                }
                                )
                        }
                        <tr>
                          
                                        <td colSpan={9}></td>
                                    
                            <td style={{ textAlign: 'right' }}><strong>{Utils.N(grandTotal)}</strong></td>
                        </tr>
                        {
                            volumeDiscount != 0 && <>
                                <tr>
                                    <td colSpan={8} style={{ textAlign: 'right' }}>Volume Discount :</td>
                                    <td style={{ textAlign: 'right' }}><strong>{Utils.N(volumeDiscount).replace("-","")}</strong></td>
                                </tr>
                                {
                                   ((grandTotal + volumeDiscount)>0)?<tr>
                                   <td colSpan={8} style={{ textAlign: 'right' }}>TOTAL :</td>
                                   <td style={{ textAlign: 'right' }}><strong>{Utils.N(grandTotal + volumeDiscount)}</strong></td>
                               </tr>:""
                                }
                                
                            </>
                        }
                        <tr>
                            <td colSpan={10} style={{ textAlign: 'right' }}>Taxes & Duties additional, as applicable</td>
                        </tr>
                    </tbody>
                </table>
            </div> 
                                </div>

                               
                                
                                
                                
                                
                                </> : <></>
            
    }</>
            
    )
}
